import { takeEvery } from 'redux-saga'

import actions from 'actions'
import { signupSubmitSaga, signupSubmitSuccessSaga } from './signup-sagas'

export function* watchSignupSubmit() {
  yield* takeEvery(actions.SIGNUP_SUBMIT, signupSubmitSaga)
}

export function* watchSignupSubmitSuccess() {
  yield* takeEvery(actions.SIGNUP_REQUEST.SUCCESS, signupSubmitSuccessSaga)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/signup/signup-watchers.js
 **/